import { render, staticRenderFns } from "./float.vue?vue&type=template&id=6c84b0f4&lang=pug&"
import script from "./float.vue?vue&type=script&lang=js&"
export * from "./float.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports